import React from 'react';
import { CheckCircle, MapPin } from 'lucide-react';
import { useCMS } from '../../context/CMSContext';

const COVERAGE_SERVICES = ['Full Truck Load (FTL)', 'Part Truck Load (PTL)', 'Over Dimensional Cargo', 'Warehousing & Distribution'];

export const CoverageSection = () => {
  const cms = useCMS();
  const stats = cms?.coverage?.stats || [];
  const cities = cms?.coverage?.cities || [];

  return (
    <section id="coverage" className="py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 dark:from-black dark:via-slate-950 dark:to-black relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wMyI+PHBhdGggZD0iTTM2IDE0YzAtNi42MjcgNS4zNzMtMTIgMTItMTJzMTIgNS4zNzMgMTIgMTItNS4zNzMgMTItMTIgMTItMTItNS4zNzMtMTItMTJ6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-50" />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-amber-500/20 text-amber-400 rounded-full text-sm font-bold mb-4">COVERAGE</span>
          <h2 className="font-outfit text-4xl font-black text-white mb-4">PAN India Reach</h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">Our extensive network connects every corner of the country</p>
        </div>
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="grid grid-cols-2 gap-6">
              {stats.map(stat => (
                <div key={stat.label} className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                  <div className="text-4xl font-black text-amber-500 mb-2">{stat.value}</div>
                  <p className="text-white/80">{stat.label}</p>
                </div>
              ))}
            </div>
            <div className="mt-8 space-y-3">
              {COVERAGE_SERVICES.map(svc => <div key={svc} className="flex items-center gap-3 text-white/80"><CheckCircle className="w-5 h-5 text-amber-500" /><span>{svc}</span></div>)}
            </div>
          </div>
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
            <h3 className="font-outfit text-2xl font-bold text-white mb-6">Major Coverage Areas</h3>
            <div className="grid grid-cols-2 gap-4">
              {cities.map(city => <div key={city} className="flex items-center gap-3 text-white/80"><MapPin className="w-4 h-4 text-amber-500" /><span>{city}</span></div>)}
            </div>
            <p className="text-sm text-white/60 mt-6">Delivering across all of India — from major metros to remote industrial corridors</p>
          </div>
        </div>
      </div>
    </section>
  );
};
